import React from "react";
import Testimonials from "../newRecommends/NewRecommends";
// Import all testimonial images
import recommend1 from "../../images/נטלי שוורץ המלצות 1.webp";
import recommend2 from "../../images/נטלי שוורץ המלצות 2.webp";
import recommend3 from "../../images/נטלי שוורץ המלצות 3.webp";
import recommend4 from "../../images/נטלי שוורץ המלצות 4.webp";
import recommend5 from "../../images/נטלי שוורץ המלצות 5.webp";
import recommend6 from "../../images/נטלי שוורץ המלצות 6.webp";
import recommend7 from "../../images/נטלי שוורץ המלצות 7.webp";
import recommend8 from "../../images/נטלי שוורץ המלצות 8.webp";
import recommend9 from "../../images/נטלי שוורץ המלצות 9.webp";
import recommend10 from "../../images/נטלי שוורץ המלצות 10.webp";

import styles from "./RecommendsScreen.module.css";
import Button from "../button/Button";

const RecommendsScreen = () => {
  // Create array of testimonial images
  const testimonialImages = [
    { src: recommend6 },
    { src: recommend4 },
    { src: recommend5 },
    { src: recommend8 },
    { src: recommend9 },
    { src: recommend10 },
    { src: recommend1 },
    { src: recommend2 },
    { src: recommend3 },
    { src: recommend7 },
  ];

  return (
    <>
      <div className={styles.recommendsContainer}>
        <div className={styles.testimonialsWrapper}>
          <Testimonials testimonialImages={testimonialImages} />
        </div>
      </div>
      <Button text="נטלי, אני רוצה להפוך את העסק למותג!"/>
    </>
  );
};

export default RecommendsScreen;